import React from 'react';

// eslint-disable-next-line react/prefer-stateless-function
class AudioBeep extends React.Component {
  render(): JSX.Element {
    return (
      // eslint-disable-next-line jsx-a11y/media-has-caption
      <audio loop={true}>
        <source src="/static/beep.mp3" />
        <source src="/static/beep.ogg" />
      </audio>
    );
  }
}
// "primes" an audio node for later, user-independent playback
function prime(audioNode: HTMLAudioElement): void {
  // If it's already playing, there's no need to do it (and doing so would cut off the audio).
  if (!audioNode.paused) {
    return;
  }
  audioNode.muted = true;
  audioNode.play();
  audioNode.pause();
  // Some browsers don't have duration, so fall back to 1s.
  const duration = audioNode.duration * 1000 || 1000;
  // Because FF still plays the audio through once even if you pause, and unsetting muted too
  // soon results in the audio being heard, we need to wait for the play to complete before
  // muting.
  // Technically this means that you'll not hear anything if this audio node goes off in the next
  // second or so, but that's assumed to not happen when you're priming.
  // eslint-disable-next-line no-return-assign
  setTimeout(() => (audioNode.muted = false), duration);
}

export {AudioBeep as Component, prime};
